import { Pipe, PipeTransform } from '@angular/core';
import { DataType } from '../models/enums/common.enum';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../services/shared.service';
import { GlobalContants } from '../constants/global.contants';

@Pipe({
  name: 'reportDataValueType'
})
export class ReportDataValueTypePipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
    private sharedService: SharedService
  ){}

  transform(value: number, lang?: string): string {
    switch (value) {
      case DataType.percentage:
        return '%';
        break;
      case DataType.unit:
        return 'm\u00B2';
        break;
      case DataType.squareMeter:
        return this.translate.instant('reports.sqm');
        break;
      case DataType.squareMeterWithBracket:
        return `${this.translate.instant('reports.sqm')}`;
        break;
      case DataType.squareFeet:
        return this.translate.instant('reports.feet_unit');
        break;
      case DataType.squareFeetWithBracket:
        return `${this.translate.instant('reports.feet')}`;
        break;
      case DataType.currencyCode:
        return `(${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))})`;
        break;
      case DataType.currencyWithSquareMeter:
        return `(${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant('reports.sqm_unit')})`;
        break;
      case DataType.monthly:
        return this.sharedService.priceCalculation$() === this.sharedService.priceYearly ? `(${this.translate.instant('reports.annual')})` : `(${this.translate.instant('reports.monthly')})`;
        break;
      case DataType.currencyWithSquareMonthly:
        return `(${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant('reports.sqm_unit')} ${this.sharedService.priceCalculation$() === this.sharedService.priceYearly ? this.translate.instant('reports.annual') : this.translate.instant('reports.monthly')})`;
        break;
      case DataType.currencyMonthly:
        return `(${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))} ${this.sharedService.priceCalculation$() === this.sharedService.priceYearly ? this.translate.instant('reports.annualLowerCase') : this.translate.instant('reports.monthly')})`;
        break;
      case DataType.countWithBracket:
        return `${this.translate.instant('reports.countWithBracket')}`;
        break;
      case DataType.yr:
        return `${this.translate.instant('reports.yrWithBracket')}`;
        break;
      case DataType.officeSqmBracket:
        return `(${this.translate.instant('reports.office')})(${this.translate.instant('sqm_unit')})`;
        break;
      case DataType.retailSqmBracket:
        return `(${this.translate.instant('retail')})(${this.translate.instant('sqm_unit')})`;
        break;
      case DataType.officeCurrencySqm:
        return `(${this.translate.instant('reports.office')})(${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant('reports.sqm_unit')})`;
        break;
      case DataType.retailCurrencySqm:
        return `(${this.translate.instant('retail')})(${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant('reports.sqm_unit')})`;
        break;
      case DataType.currencyWithSquareFeet:
        return `(${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant('reports.feet_unit')})`;
        break;
      case DataType.currencyWithSquareYearly:
        return `(${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant('reports.sqm_unit')} ${this.translate.instant('reports.yearly')})`;
        break;
      case DataType.unitSize:
        return `(${this.translate.instant('reports.unitSize').toUpperCase()})`;
        break;
      case DataType.unitNumber:
        return `(${this.translate.instant('reports.unit_number').toUpperCase()})`;
        break;
      case DataType.inBuiltUp:
        return `(${this.translate.instant('reports.CAP_Rate2').toLowerCase()})`;
        break;
        case DataType.source:
      return `(${this.translate.instant('reports.source').toLowerCase()})`;
       break;
      case DataType.recordType:
      return `(${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))})(${this.translate.instant('reports.record_type').toUpperCase()})`;
       break;
      default:
        return '';
    }
  }

}
